module.exports = __webpack_public_path__ + "img/salvo.2b9b8c5b.svg";